import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';
import logo from '../../assets/logo.png';
import { useAuth } from '../../context/AuthContext';

const EMPLOYEE_MGMT_EMAILS = [
  'gurpreet@densitypharmachem.com',
  'prakash@densitypharmachem.com',
];

const Sidebar = ({ collapsed, onToggle, mobileOpen, onMobileClose }) => {
  const { user } = useAuth();

  const menuItems = [
    {
      label: 'Home',
      icon: '🏠',
      path: '/',
      show: true,
      end: true,
    },
    // Everyone sees appraisal form
    {
      label: 'Appraisal Form',
      icon: '📋',
      path: '/appraisal',
      show: true,
    },
    // Manager, HOD, HR see report
    {
      label: 'Appraisal Report',
      icon: '📊',
      path: '/appraisal-report',
      // Prakash also gets it so they can reach the review-period manager (freeze/deadlines)
      show: user?.isManager || user?.isHOD || user?.isHR
        || EMPLOYEE_MGMT_EMAILS.includes(user?.email?.toLowerCase()),
    },
    // HR + Prakash see employees
    {
      label: 'Employees',
      icon: '👤',
      path: '/employees',
      show: EMPLOYEE_MGMT_EMAILS.includes(user?.email?.toLowerCase()),
    },
    // Everyone sees the Code of Conduct acknowledgement; HR also gets the submission report
    // on the same page.
    {
      label: 'Code of Conduct Acknowledgement',
      icon: '📜',
      path: '/code-of-conduct',
      show: true,
    },
    {
      label: 'Rewards & Recognition',
      icon: '🏆',
      path: '/rnr',
      show: true,
    },
    {
      label: 'Long Service Awards',
      icon: '🎖️',
      path: '/lsa',
      show: true,
    },
    {
      label: 'HRMS',
      icon: '🏢',
      path: '/hrms',
      show: true,
    },
    {
      label: 'Birthdays',
      icon: '🎂',
      path: '/birthdays',
      show: true,
    },
  ].filter((item) => item.show);

  return (
    <>
      {mobileOpen && (
        <div className={styles.overlay} onClick={onMobileClose} />
      )}
      <aside
        className={`${styles.sidebar}
          ${collapsed ? styles.collapsed : ''}
          ${mobileOpen ? styles.mobileOpen : ''}`}
      >
        <div className={styles.logoArea}>
          <img src={logo} alt="Density Pharmachem" className={styles.logo} />
          <button className={styles.collapseBtn} onClick={onToggle}>
            {collapsed ? '→' : '←'}
          </button>
        </div>

        <nav className={styles.nav}>
          {menuItems.map((item) => (
            <div key={item.path} className={styles.navItemWrapper}>
              <NavLink
                to={item.path}
                end={item.end}
                className={({ isActive }) =>
                  `${styles.navItem} ${isActive ? styles.active : ''}`
                }
                onClick={onMobileClose}
              >
                <span className={styles.navIcon}>{item.icon}</span>
                <span className={styles.navLabel}>{item.label}</span>
              </NavLink>
              {collapsed && (
                <span className={styles.tooltip}>{item.label}</span>
              )}
            </div>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.version}>v1.0.0</div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;